import React, { useState } from 'react';

const Parametre = () => {
    

    return (
        <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
            page documents
        </div>
    );
}

export default Parametre;